var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"customdim"}),_c('div',{staticClass:"loader-image"},[_c('img',{attrs:{"src":require("../../assets/weavr_loader.svg"),"width":"100","height":"40","alt":"loader"}})]),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }